import classNames from 'classnames';

import { IProps } from './styled-input';

type CreateInputCSS = Pick<
  IProps,
  'labelPos' | 'labelStyle' | 'labelStyleClass' | 'variant'
> & { className?: string; hasError?: boolean };

const createButtonCSS = ({
  variant,
  labelPos,
  className,
  labelStyleClass,
  hasError = false,
}: CreateInputCSS) => {
  /* select css classes based on the variant of input */
  const inputCx = classNames(
    'block relative focus:ring-0 focus:border-gray-500',
    {
      'rounded-md bg-gray border-gray-100': variant === 'solid',
      'border-0 border-b-2 border-gray-200 focus:border-black': variant === 'underline',
      '!border-red-light focus:!border-red-light': hasError,
    },
    className,
  );

  /* label's position will be changed based on the given position */
  const labelCx = classNames(
    {
      'order-1 text-center mt-1': labelPos === 'bottom',
    },
    labelStyleClass,
  );

  /* label's position will be changed based on the given position */
  const containerCx = classNames('flex ', {
    'flex-row justify-between items-center': labelPos === 'left',
    'flex-col justify-center': labelPos === 'bottom',
  });

  return { containerCx, labelCx, inputCx };
};

export default createButtonCSS;
